var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShopping(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.67 9.25865L15.9831 3.48087C16.0779 3.0637 15.7609 2.66645 15.3331 2.66645H4.42245L4.16783 1.42173C4.10439 1.11148 3.83139 0.888672 3.5147 0.888672H0.666667C0.298472 0.888672 0 1.18714 0 1.55534V1.99978C0 2.36798 0.298472 2.66645 0.666667 2.66645H2.60786L4.5592 12.2063C4.09236 12.4748 3.77778 12.9782 3.77778 13.5553C3.77778 14.4145 4.47422 15.1109 5.33333 15.1109C6.19245 15.1109 6.88889 14.4145 6.88889 13.5553C6.88889 13.12 6.70981 12.7266 6.42156 12.4442H12.2451C11.9569 12.7266 11.7778 13.12 11.7778 13.5553C11.7778 14.4145 12.4742 15.1109 13.3333 15.1109C14.1924 15.1109 14.8889 14.4145 14.8889 13.5553C14.8889 12.9395 14.5309 12.4072 14.0117 12.1552L14.1649 11.4809C14.2598 11.0637 13.9427 10.6665 13.5149 10.6665H6.05881L5.877 9.77756H14.0199C14.3312 9.77756 14.601 9.56217 14.67 9.25865Z",
    fill: "#004E98"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShopping);
export default __webpack_public_path__ + "static/media/shopping.ac7bd46214775812885aaf2d9c72ac4b.svg";
export { ForwardRef as ReactComponent };